module.exports = __webpack_public_path__ + "assets/img/step6.c5a48fb7.png";